module.exports = __webpack_public_path__ + "files/1d9a769a6a0dfbfe3fd0ecbe29ebc44e.png";